import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { BiLogIn } from 'react-icons/bi';
import DropdownUser from '../DropdownUser';
import { useAuth } from '../../auth/context/AuthContext';
import logo from '../../static/logo.png';
import { PUBLIC_NAV_ABOUT, PUBLIC_NAV_MOBILE_FLAT, PUBLIC_NAV_PRODUCTS } from './publicNavBlueprint';
import { NavDropdownLink, NavMobileLink, dropdownPanelClass } from './PublicNavPrimitives';

export default function PricingHeader() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { user, logout } = useAuth();

  return (
    <header className="bg-white header-shadow dark:bg-boxdark-2 dark:border-b dark:border-gray-100/10">
      <nav className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8" aria-label="Global">
        <div className="flex items-center">
          <Link to="/" className="flex items-center -m-1.5 p-1.5 text-gray-900 duration-300 ease-in-out hover:text-yellow-500">
            <img className="h-8 w-8" src={logo} alt="Pricing Table AI" />
            <span className="ml-2 text-sm font-semibold leading-6 dark:text-white">PricingTable AI</span>
          </Link>
        </div>
        <div className="flex lg:hidden">
          <button
            type="button"
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700 dark:text-white"
            onClick={() => setMobileMenuOpen(true)}
          >
            <span className="sr-only">Open main menu</span>
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
            </svg>
          </button>
        </div>
        <div className="hidden lg:flex lg:gap-x-8">
          <div className="group relative">
            <button
              type="button"
              className="text-sm font-semibold leading-6 text-gray-900 dark:text-white duration-300 ease-in-out hover:text-yellow-500"
              aria-haspopup="true"
            >
              Products
            </button>
            <div className={dropdownPanelClass}>
              {PUBLIC_NAV_PRODUCTS.map((item) => (
                <NavDropdownLink key={item.label} item={item} />
              ))}
            </div>
          </div>
          <div className="group relative">
            <button
              type="button"
              className="text-sm font-semibold leading-6 text-gray-900 dark:text-white duration-300 ease-in-out hover:text-yellow-500"
              aria-haspopup="true"
            >
              About
            </button>
            <div className={dropdownPanelClass}>
              {PUBLIC_NAV_ABOUT.map((item) => (
                <NavDropdownLink key={item.label} item={item} />
              ))}
            </div>
          </div>
        </div>
        <div className="hidden lg:flex gap-3 items-center">
          {user ? (
            <DropdownUser user={user} onLogout={logout} />
          ) : (
            <Link to="/login" className="text-sm font-semibold leading-6">
              <div className="flex items-center duration-300 ease-in-out text-gray-900 hover:text-yellow-500 dark:text-white">
                Log in <BiLogIn size="1.1rem" className="ml-1 mt-[0.1rem]" />
              </div>
            </Link>
          )}
        </div>
      </nav>
      
      {/* Mobile menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden">
          <div className="fixed inset-0 z-50" />
          <div className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white bg-opacity-95 header-backdrop dark:bg-boxdark-2 dark:bg-opacity-95 px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
            <div className="flex items-center justify-between">
              <Link to="/" className="-m-1.5 p-1.5">
                <span className="text-2xl font-bold text-yellow-500">PricingTable AI</span>
              </Link>
              <button
                type="button"
                className="-m-2.5 rounded-md p-2.5 text-gray-700 dark:text-gray-300"
                onClick={() => setMobileMenuOpen(false)}
              >
                <span className="sr-only">Close menu</span>
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div className="mt-6 flow-root">
              <div className="-my-6 divide-y divide-gray-500/10">
                <div className="space-y-2 py-6">
                  {PUBLIC_NAV_MOBILE_FLAT.map((item) => (
                    <NavMobileLink key={item.label} item={item} onNavigate={() => setMobileMenuOpen(false)} />
                  ))}
                </div>
                <div className="py-6">
                  {user ? (
                    <div className="-mx-3 block rounded-lg px-3 py-2">
                      <div className="flex items-center justify-between">
                        <span className="text-base font-semibold leading-7 text-gray-900 dark:text-white">
                          {user.email}
                        </span>
                        <button
                          onClick={() => {
                            logout();
                            setMobileMenuOpen(false);
                          }}
                          className="text-base font-semibold leading-7 text-gray-900 dark:text-white hover:text-yellow-500"
                        >
                          Log out
                        </button>
                      </div>
                    </div>
                  ) : (
                    <Link
                      to="/login"
                      className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 dark:text-white hover:bg-gray-50 dark:hover:bg-gray-50"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      <div className="flex items-center">
                        Log in <BiLogIn size="1.1rem" className="ml-1" />
                      </div>
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
